import { usePathname } from '@/hooks/location/usePathname';
import { useLocale } from '@/hooks/useLocale';
import { useUserLocale } from '@/hooks/useUserLocale';
import routesGenerator from '@/router/routesGenerator';
import { isPageTranslated, isSupportedLocale } from '@/utils/locale';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NOT_FOUND, pathToAction } from 'redux-first-router';

const routesMap = routesGenerator();

/**
 * Redirects the current route to the preferred locale.
 *
 * This is used to handle the case where a user lands on a non-preferred locale for a certain route.
 * (often happens when linking from `en` / non-translated content back to a translated page).
 */
export function LocaleRedirect() {
  const locale = useLocale();
  const [preferredLocale] = useUserLocale();
  const pathname = usePathname();
  const dispatch = useDispatch();

  useEffect(() => {
    const url = new URL(window.location.href);
    const noRedirect = url.searchParams.has('no-redirect');

    if (
      !noRedirect &&
      isSupportedLocale(preferredLocale) &&
      locale !== preferredLocale
    ) {
      const safeTargetUrl = `/${preferredLocale}` + pathname + url.search;

      const action = pathToAction(safeTargetUrl, routesMap);

      if (action.type !== NOT_FOUND && isPageTranslated(action.type)) {
        dispatch(action);
      }
    }
  }, [locale, preferredLocale, pathname]);

  return <></>;
}
